import { useEffect, useState } from "react";
import PageHead from "../../components/PageHead";
import { useTranslation } from "react-i18next";
import ModalUsers from "../../components/Modal/ModalUsers";
import Table from "../../components/Table";
import DeprecatedPagination from "../../components/DeprecatedPagination";
import { TFunction } from "i18next";
import { getAxiosInstance } from "../../utils/axiosInstance";
import { toast } from "react-toastify";
import EditModalUser from "../../components/Modal/EditModalUser";
import ResetDefaultPasswordModal from "../../components/Modal/ResetDefaultPasswordModal";


const getColumns = (t: TFunction<any>) => [
  {
    Header: t("CRT_NO"),
    accessor: 'no'
  },
  {
      Header: t("Username"),
      accessor: 'userName'
  },
  {
      Header: t("Email"),
      accessor: 'email'
  },
  {
      Header: t("Display_Name"),
      accessor: 'displayName'
  },
  {
      Header: t("Roles"),
      accessor: 'roles'
  }
]

interface User {
  id: string,
  userName: string,
  email: string,
  normalizedEmail: string,
  isDeleted: boolean,
  displayName: string,
  original_roles: string[],
  roles: {
      id: string,
      name: string,
      normalizedName: string,
      concurrencyStamp: string
    }[]
}

type ApiResponse = {
  roles: string[]
  isDeleted: boolean
  displayName: string
  id: string
  userName: string
  normalizedUserName: string
  email: string
  normalizedEmail: string
  emailConfirmed: boolean
  passwordHash: any
  securityStamp: string
  concurrencyStamp: string
  phoneNumber: any
  phoneNumberConfirmed: boolean
  twoFactorEnabled: boolean
  lockoutEnd: any
  lockoutEnabled: boolean
  accessFailedCount: number
  placesOfBusiness: {
    id: string
    name: string
    address: string
    companyName: string
    companyId: string
  }[],
}[];



const Users = () => {
  const [newUserModal, setNewUserModal] = useState<boolean>(false);
  const [users, setUsers] = useState<any[]>([]);
  const [length, setLength] = useState<number>(0);
  const [editModalUsers, setEditModalUsers] = useState<boolean>(false);
  const [editModalUsersData, setEditModalUsersData] = useState<any>({});
  const [userId, setUserId] = useState<string>("");
  const [restPassModal, setResetPassModal] = useState<boolean>(false);

  const { t } = useTranslation("translations");

  const fetchData = async (currentPage: number = 1, perPage: number = 10) => {
    try {
      const res = await getAxiosInstance().get('/Users', { params: {
        PageNumber: currentPage,
        PageSize: perPage
      }});
          
      setUsers(transformResponse(res.data.userInfo, (currentPage - 1) * perPage));
      setLength(res.data.count);

    } catch (e) {
      console.log(e);
      toast.error(
        t("SOMETHING_WENT_WRONG"),
        { position: toast.POSITION.BOTTOM_RIGHT }
      );
    }
  }

  const transformResponse = (data: ApiResponse, currentItem: number = 0) => {
    const processedData = [];
    let i = currentItem;
    for(const d of data){
        i++;
        processedData.push({
            no: i,
            userName: d.userName,
            email: d.email,
            normalizedEmail: d.normalizedEmail,
            isDeleted: d.isDeleted,
            displayName: d.displayName,
            roles: d.roles.toString(),
            original_roles: d.roles,
            id: d.id,
            placesOfBusiness: d.placesOfBusiness
        })
    }
   
    return processedData;
  }

  const editDataUsers = (data:any) => {
    setEditModalUsers(true);
    setEditModalUsersData(data);
  }

  useEffect(() => {
    fetchData();
  }, [])

  return (
    <>
        <PageHead
          addTooltip={t("Users")}
          name={t("Users")}
          onAddModal={() => setNewUserModal(true)}
         />
         <ModalUsers   isOpen={newUserModal} onClose={() => {
            setNewUserModal(false);
            fetchData();
          }}/>
           <Table
                columns={getColumns(t)}
                data={users}
                onRowClick={data => {editDataUsers(data)}}
                Pagination={
                  <DeprecatedPagination
                    dataLegth={length}
                    fetchData={(page, perPage) => fetchData(page, perPage)}
                  />
                }
            />
          <EditModalUser
            isOpen ={editModalUsers}
            data = {editModalUsersData}
            onClose={
                () => {
                    setEditModalUsers(false);
                    fetchData()
                }
            }
            resetPassword={(userId: string) => { setEditModalUsers(false); setUserId(userId); setResetPassModal(true) }}
          />
          <ResetDefaultPasswordModal
            isOpen = {restPassModal}
            userId={userId}
            onClose={() => { 
              setResetPassModal(false);
              fetchData();
            }}
          />
    </>
  )
};

export default Users;